<template>
  <!-- App -->
  <div id="app">
    <!-- Statusbar -->
    <f7-statusbar></f7-statusbar>

    <!-- Main Views -->
    <f7-views>
      <f7-view color-theme="blue" id="main-view" navbar-through :dynamic-navbar="true" main>
        <!-- Pages -->
        <f7-page color-theme="blue">
          <!-- Material Theme Navbar -->
          <!-- iOS Theme Navbar -->
          <f7-navbar>
            <f7-nav-title>Busquemos</f7-nav-title>
          </f7-navbar>
          <!-- Page Content -->
          <f7-messages color-theme="blue">
            <p class="messages-title">{{ now }}</p>
            <div
              class="messages-message"
              :key="`k-${i}`"
              v-for="(message, i) in messages"
            >
              <f7-message
                :class="getType(message.uid)"
                :text="message.text"
                :label="message.label"
                :color="getType(message.uid) === 'sent' ? 'blue' : ''"
                :date="message.date"
                :name="message.index === 0 ? message.name : ''"
                :avatar="message.avatar"
                :image="message.image"
                :type="getType(message.uid)"
                :day="message.day"
                :first="message.first"
                :last="message.last"
                :tail="message.last"
                :time="message.time"
                @click="onClick"
                @click:text="onTextClick"
                @click:name="onNameClick"
                @click:avatar="onAvatarClick"
                v-if="!message.image"
              >
                <div slot="text" class="msg" v-html="message.text"/>
                <div class="message-date" slot="bubble-end">
                  {{ message.date }}
                </div>
              </f7-message>
              <div
                class="message message-received received message-appear-from-bottom"
                :class="{
                  'message-tail': message.last,
                  'message-last': message.last
                }"
                v-if="message.image"
              >
                <div
                  class="message-avatar"
                  style="background-image: url('https://s3.amazonaws.com/testing.admin/Header_LandingChatbot_Mobile.jpg');"
                >
                </div>
                <div class="message-bubble messages-image">
                  <a target="_blank" rel="noopener noreferrer" class="external" :href="message.image">
                    <img loading="lazy" :src="message.image" :alt="message.text" />
                  </a>
                  <div class="message-date">
                    {{ message.date }}
                  </div>
                </div>
              </div>
            </div>
            <div class="messages-message opt-wrapper" v-if="options.length > 0">
              <button
                class="question-opts message message-received received message-appear-from-bottom"
                v-for="opt in options"
                v-bind:key="opt.text"
                @click="
                  onSubmit({ text: opt.text, callback: opt.callback_data })
                "
              >
                {{ opt.text }}
              </button>
            </div>
            <f7-message
              v-if="loading"
              type="received"
              :typing="true"
              :first="true"
              :last="true"
              :tail="true"
              header="Busquemos está escribiendo..."
              avatar="https://s3.amazonaws.com/testing.admin/Header_LandingChatbot_Mobile.jpg"
            ></f7-message>
          </f7-messages>
          <f7-messagebar
            placeholder="Mensaje"
            send-link="Enviar"
            ref="messagebar"
            @keyup.enter.native="onKeyEnter"
            @submit="onSubmit"
          >
          </f7-messagebar>
        </f7-page>
      </f7-view>
    </f7-views>
  </div>
</template>

<script>
import * as $ from "jquery";
import DOMPurify from "dompurify";
import axios from "axios";

export default {
  data: function () {
    return {
      name: "Anónimo",
      avatar:
        "https://s3.amazonaws.com/testing.admin/Header_LandingChatbot_Mobile.jpg",
      uid: "none",
      auth: false,
      text: "",
      loading: false,
      messages: [],
      options: [],
      myMessagebar: null,
      now: new Date().toLocaleDateString("es-MX", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    };
  },
  methods: {
    replaceURLWithHTMLLinks: (text) => { 
      if (text) {
        const exp = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;

        return text.replace(exp,"<a class='external' href='$1' target='_blank' rel='noopener noreferrer'>$1</a>");
      }

      return;
    },
    openImage: (imageURL) => window.open(imageURL),
    onClick: function (event) {},
    onAvatarClick: function () {},
    onTextClick: function () {},
    onNameClick: function () {},
    onKeyEnter(event) {
      let text = event.target.value;
      if (text.trim().length === 0) return;
      this.myMessagebar.clear();
      this.onSubmit(text);
    },
    onSubmit: async function (text, clear) {
      //if (text.trim().length === 0) return;
      if (text !== "") {
        this.myMessagebar.clear();

        let newMsg = {
          index: 0,
          name: this.name,
          first: true,
          last: true,
          // avatar: this.avatar,
          uid: this.uid,
          text:
            typeof text === "object" && text !== null && !Array.isArray(text)
              ? text.text
              : text,
          date: (function () {
              var now = new Date();

              return now.toLocaleTimeString("es-MX").substring(0, 5);
            })(),
        };

        let slsMsg = {
          update_id: 241625864,
          message: {
            message_id: 1700,
            from: {
              id: this.uid,
              is_bot: false,
              first_name: this.name,
              last_name: this.name,
              username: this.name,
              language_code: "en",
            },
            chat: {
              id: navigator.userAgent,
              first_name: "-",
              last_name: "-",
              username: "anonimo",
              type: "private",
            },
            date: (function () {
              var now = new Date();

              return now.toLocaleTimeString("es-MX").substring(0, 5);
            })(),
            text:
              typeof text === "object" && text !== null && !Array.isArray(text)
                ? text.text
                : text,
          },
        };
        this.messages.push({
          ...newMsg, // expand object
        });

        if (typeof text === "object" && text !== null && !Array.isArray(text)) {
          slsMsg.callback = text.callback;
        }

        this.options = [];
        let response;
        // Clear Message Bar
        this.loading = true;
        try {
          response = await axios.post(
            "https://tee100llqe.execute-api.us-east-1.amazonaws.com/stage/webapp/webhook",
            slsMsg
          );
        } finally {
          this.loading = false;
        }
        //console.log(response);
        for (const [i, m] of response.data.messages.entries()) {
          let botMsg = {
            index: i,
            name: "Busquemos",
            avatar: this.avatar,
            uid: 345345345,
            text: DOMPurify.sanitize(
              this.replaceURLWithHTMLLinks(m.text),
              {
                USE_PROFILES: {html: true}
              }
            ),
            first: i === 0,
            last: i === response.data.messages.length - 1,
            image: m.photo,
            date: (() => {
              var now = new Date();

              return now.toLocaleTimeString("es-MX").substring(0, 5);
            })(),
          };
          //console.log("----m----", m);
          //console.log("---botMsg---", botMsg);
          this.messages.push({
            ...botMsg, // expand object
          });
          if (m.reply_markup) {
            this.options = m.reply_markup.inline_keyboard;
          }
          await new Promise(resolve => setTimeout(resolve, 1000));
        }

        if (typeof clear === "function") {
          clear();
        }
      }
    },
    getType: function (uid) {
      return uid == this.uid ? "sent" : "received";
    },
    signIn: function () {
      var vm = this;
    },
  },
  created: async function () {
    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
      // set all elements owning target to target=_blank
      if ('target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
      }
    });
    this.$nextTick(function () {
      this.myMessagebar = $(".messagebar")[0].f7Messagebar;
      this.onSubmit("hola");
      this.messages.shift();
    });
  },
};
</script>

<style>
.opt-wrapper {
  margin-left: 29px;
}
.msg {
  white-space: pre-line;
}
.btn-send {
  line-height: 44px;
  height: 44px;
  text-decoration: none;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-align: center;
  align-items: center;
  transition-duration: .3s;
  transform: translateZ(0);
  color: #007aff;
  border: 0;
  background-color: transparent;
  font-size: 17px;
}
button.question-opts {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 35px;
  max-width: calc(70% - 14px) !important;
  border-radius: 16px;
  border: 1px solid #e5e5ea;
  background-color: #fff;
  margin: 5px 14px !important;
  padding: 5px 8px;
  cursor: pointer;
  text-align: center;
  color: rgb(0, 122, 255);
}
.messages-title {
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
}
.messages-message {
  margin-top: 1px;
  margin-bottom: 1px;
}
.messages-message .message {
  margin-top: 1px;
  margin-bottom: 1px;
}
.messages-image {
  background-color: #e5e5ea;
  border: 1px solid #e5e5ea;
  border-radius: 16px;
  padding-top: 0px;
  padding-right: 16px;
  padding-bottom: 9px;
  padding-left: 22px;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.messages-image img {
  max-width: 100%;
  margin: auto;
}
.messages-image-avatar.message-avatar {
  opacity: 1;
  margin-left: 10px;
}
.message-received {
  max-width: 70%;
}
.message-sent {
  max-width: 100%;
  padding-left: 30%;
}
.messagebar ~ .page-content {
  padding-bottom: 44px;
}
.message-date {
  font-size: 12px;
  margin-top: 4px;
  opacity: .8;
}
.ios .message-sent .message-bubble {
  background-color: rgb(0, 122, 255);
}

@media screen and (max-width: 768px) {
  .ios .message-bubble,
  .question-opts {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// app.vue?e860c950